'use strict';

import $ from 'jquery';
import formHelper from './form-helper';
import { Form } from './form';

const JS_CLASS = 'js-form-testament';

class FormTestament extends Form {
  addListeners() {
    super.addListeners();

    this.dom.$fieldsHolder = this.dom.$form.find('.' + JS_CLASS + '__fields');
    this.dom.$deliveryMethod = this.dom.$form.find('.' + JS_CLASS + '__delivery-method input');
    this.dom.$postOffice = this.dom.$form.find('.' + JS_CLASS + '__post-office');

    this.dom.$deliveryMethod.on('click change', () => {
      if (!this.dom.$fieldsHolder.hasClass('is-visible')) {
        this.dom.$fieldsHolder.addClass('is-visible');
      }
    });

    formHelper.postalCode.on('fetchOffice', (postOffice) => {
      this.dom.$postOffice.val(postOffice);
      this.dom.$postOffice.trigger('change');
    });
  }
}

export default {
  initForms: () => {
    $('.' + JS_CLASS).each(function () {
      const $form = $(this);

      if($form.data('form-name') === 'testament') {
        const form = new FormTestament(this);
        form.init();
      }
    });
  }
}
